module.exports = __webpack_public_path__ + "img/general-1.2.987441ce.svg";